import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = "Riya — AI Sales Manager";
let _cachedName = null;
let _pending = null;

/**
 * Returns the AI Manager's configured display name. Cached in-memory so the
 * floating widget and the admin page don't refetch on every mount.
 * updateName() is admin-only (server enforces).
 */
export function useAIManagerName() {
  const [name, setName] = useState(_cachedName || DEFAULT);
  const [loading, setLoading] = useState(!_cachedName);

  useEffect(() => {
    let alive = true;
    if (_cachedName) { setLoading(false); return; }
    if (!_pending) {
      _pending = api.get("/ai/manager/config")
        .then((r) => { _cachedName = r.data?.name || DEFAULT; return _cachedName; })
        .catch(() => DEFAULT)
        .finally(() => { _pending = null; });
    }
    _pending.then((n) => { if (alive) { setName(n); setLoading(false); } });
    return () => { alive = false; };
  }, []);

  const updateName = useCallback(async (next) => {
    const { data } = await api.patch("/ai/manager/config", { name: next });
    _cachedName = data.name;
    setName(data.name);
    return data.name;
  }, []);

  return { name, loading, updateName };
}
